import { createSlice } from '@reduxjs/toolkit'
import moment from "moment";

export interface CnAState {
    isLoading: boolean,
    data: object,
    archived_data: object,
    datum_id_open: number,
    datum_id_open_data: number,
    pastDate: string,
}

const initialState: CnAState = {
    isLoading: true,
    data: null,
    archived_data: null,
    datum_id_open: 0,
    datum_id_open_data: undefined,
    pastDate: moment().utc().endOf("month").format("YYYY-MM-DD"),
}

export const connectAndAlignSlice = createSlice({
    name: 'tool_cna',
    initialState,
    reducers: {
        startLoading: (state) => {
            state.isLoading = true;
        },
        setData: (state, action) => {
            state.data = action.payload
            state.isLoading = false
        },
        setArchiveData: (state, action) => {
            state.archived_data = action.payload
        },
        setDatumIdOpen: (state, action) => {
            state.datum_id_open = action.payload
        },
        setDatumIdOpenData: (state, action) => {
            state.datum_id_open_data = action.payload
        },
        setPastDate: (state, action) => {
            state.pastDate = action.payload
        }
    },
})

// Action creators are generated for each case reducer function
export const { startLoading, setData, setArchiveData, setDatumIdOpen, setDatumIdOpenData, setPastDate } = connectAndAlignSlice.actions
